import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { http, formatDetail } from "./api";
import { useNoIndex } from "../lib/seo";

export default function PortalSetPassword() {
  useNoIndex();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) return toast.error("Password must be at least 10 characters.");
    if (password !== confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await http.post("/portal/set-password", { token, password });
      toast.success("Password set. You can now sign in.");
      navigate("/portal/login");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-ink">
      <form onSubmit={submit} data-testid="portal-setpw-form" className="w-full max-w-sm border border-line bg-surface1 p-8 md:p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/bigibila-logo.png" alt="Bigibila" className="h-10 w-10" />
          <div>
            <p className="font-serif text-xl text-bone">Bigibila</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ember">Set your password</p>
          </div>
        </div>
        {!token && <p className="text-sm text-stone2 mb-6" data-testid="setpw-no-token">This link is missing its token. Use the button in your invitation email.</p>}
        <label className="font-mono text-xs uppercase tracking-[0.2em] text-stone2 block mb-2">New password (min 10 characters)</label>
        <input type="password" data-testid="portal-setpw-input" className="field-dark w-full px-4 py-3 text-sm mb-5" value={password} onChange={(e) => setPassword(e.target.value)} />
        <label className="font-mono text-xs uppercase tracking-[0.2em] text-stone2 block mb-2">Confirm password</label>
        <input type="password" data-testid="portal-setpw-confirm" className="field-dark w-full px-4 py-3 text-sm mb-8" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        <button type="submit" disabled={busy || !token} data-testid="portal-setpw-btn" className="w-full font-mono text-sm uppercase tracking-[0.2em] px-6 py-3.5 bg-ember text-ink hover:bg-emberDeep transition-colors duration-300 disabled:opacity-60">
          {busy ? "Saving…" : "Set password"}
        </button>
      </form>
    </div>
  );
}
